import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../../store/store";
import { ChangeEvent, useEffect, useState } from "react";
import { useDebouncedValue } from "../../../../utility/useDebouncedValue";
import { getClients, resetDeleteSuccess, resetUpdateSuccess } from "../../../../store/actions/clientActions";
import Header from "../../../layout/Header";
import PageHeaderProps from "../../../../model/PageHeaderProps";
import { FloatingLabel, Form } from "react-bootstrap";
import PageContainer from "../../../layout/PageContainer";
import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import Container from "../../../layout/Container";
import LoadingSpinner from "../../../../assets/components/LoadingSpinner";
import Box from "@mui/material/Box";
import Fab from "@mui/material/Fab";
import Card from "@mui/material/Card";
import Add from "@mui/icons-material/Add";
import {deleteSuccessSelector, loadingClientQuerySelector, saveSuccessSelector } from "../../../../store/selectors/clientSelector";



const ClientsListPage: React.FC<PageHeaderProps> = ({isNavOpen, setIsNavOpen}) => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const clients = useAppSelector(state => state.client.clients);
    const loading = useAppSelector(loadingClientQuerySelector); 
    const updateSuccessful = useAppSelector(saveSuccessSelector);
    const deleteSuccessful = useAppSelector(deleteSuccessSelector)
   
    const [searchText, setSearchText] = useState<string>("");  

    const debouncedSearchText = useDebouncedValue<string>(searchText, 400);

    useEffect(() => {
        dispatch(getClients({                    
            QueryString: debouncedSearchText                
        }));
    }, [dispatch, debouncedSearchText])

     useEffect(() => {
        if(updateSuccessful || deleteSuccessful) {            
            dispatch(resetUpdateSuccess());
            dispatch(resetDeleteSuccess());            
        }
    }, [updateSuccessful, deleteSuccessful, dispatch]);
    

    return <PageContainer>
            <Header title={"Clients"} isNavOpen={isNavOpen} setIsNavOpen={setIsNavOpen}>
                <FloatingLabel
                    controlId="applicantSearch"
                    label="Search"
                    className="mb-3 text-dark"
                >
                    <Form.Control
                        placeholder="Search"
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                    />
                </FloatingLabel>
            </Header>
            <Container style={{ padding: "1rem" }}>
                <Box sx={{position: "relative"}}>
                    <Fab color="secondary"
                        onClick={() => navigate("new")}
                        sx={{ position: "absolute", right: 0, top: -46}}>
                        <Add />
                    </Fab>
                </Box>

                {!loading && 
                    <TableContainer component={Card} sx={{ borderRadius: "1rem", background: "#fff", "tr:last-child td": { borderBottom: "0"}}}>
                        <Table stickyHeader>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Code</TableCell>
                                    <TableCell>Name</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {clients
                                    .map(x => (
                                        <TableRow 
                                            hover 
                                            key={x.code} 
                                            onClick={(e) => {
                                                navigate(x.clientId + "")
                                            }}
                                        >
                                            <TableCell>{x.code}</TableCell>
                                            <TableCell>{x.name}</TableCell>
                                        </TableRow>
                                    )
                                )}
                                {clients.length == 0 &&
                                    <TableRow                                      
                                        key={"NA"} 
                                    >
                                        <TableCell colSpan={2}> No clients found {(searchText.length > 0 ? "for '" + searchText + "'" : "")}</TableCell>
                                    </TableRow>
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
                }
                {loading &&
                    <Box display="flex" justifyContent="center" p="3">
                        <LoadingSpinner style={{ width: "4rem", height: "4rem"}}/>
                    </Box>
                }
            </Container>
    </PageContainer>
}

export default ClientsListPage;